<template>
  <v-navigation-drawer v-if="isShown" :value="isDrawerOpen" @input="toggleDrawer($event)" :temporary="isMobile"
    :mini-variant="!isMobile" :permanent="!isMobile" :expand-on-hover="!isMobile" clipped app fixed>
    <v-list dense nav class="py-0" avatar>
      <v-list-item two-line :class="'px-0'" :to="items[0].path" @click="toggleDrawer(false)"
        :disabled="items[0].isDisabled">
        <v-list-item-avatar>
          <img :src="require('@/assets/imgs/logo2.png')" />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ items[0].title }}</v-list-item-title>
          <!-- <v-list-item-subtitle>Subtext</v-list-item-subtitle> -->
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>
      <!-- FIX THIS! SECOND ITEM IS SUBTITLE IN EMPLOYEE -->
      <!-- <v-list-item
        v-if="items[1].isSubtitle"
        :to="items[1].path+'true'"
        @click="toggleDrawer(false)"
      >
        <v-list-item-avatar size="30" color="primary">
          <span class="white--text">{{items[1].title.slice(8,10)}}</span>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{items[1].title}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider v-if="items[1].isSubtitle"></v-divider>-->

      <v-list-item v-for="item in items.slice(1)" :key="item.title" :to="item.path" @click="toggleDrawer(false)"
        exact-active-class="active-drawer" link>
        <v-list-item-avatar size="30" color="primary">
          <span class="white--text">{{ item.title.slice(0, 2) }}</span>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { sideNav } from '@/services/constData.js'
export default {
  data() {
    return {
      isShown: true,
      drawer: false,
      items: null
    }
  },
  created() {
    this.createNavData()
  },
  methods: {
    createNavData() {
      const path = this.$route.path
      this.isShown = true
      if (path.includes('employee')) this.isShown = false
      else if (path.includes('stats')) this.items = sideNav.stats
      else if (path.includes('attend')) this.items = sideNav.reports
      else if (path.includes('población')) this.isShown = false
      else if (path.includes('payroll')) this.isShown = false
      else this.items = sideNav.emps
    },
    toggleDrawer(val) {
      if (this.isDrawerOpen && val) return
      this.$store.commit('user/toggleDrawer', val)
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    isDrawerOpen() {
      return this.$store.getters['user/isDrawerOpen']
    }
  },
  watch: {
    $route(to, from) {
      this.createNavData()
    }
  }
}
</script>

<style></style>